module.exports = __webpack_public_path__ + "img/about-3.f4879096.jpg";